import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/layouts/empty.vue").then(m => m.default || m)),
  "full-page": defineAsyncComponent(() => import("/home/runner/work/revolugo/revolugo/apps/front/platform/src/layouts/full-page.vue").then(m => m.default || m))
}